<section
  class="ds-flex ds-flex-wrap mb-4 ds-max-w-xl ds-align-middle ds-m-auto"
>
  <a
    *ngFor="let year of years; index as i"
    [attr.tabindex]="isDisabled(year) ? '-1' : '0'"
    #yearDom
    class="
      ds-w-1/3
      ds-text-center
      ds-cursor-pointer
      ds-py-xs
      ds-my-xs
      ds-text-primary-black
      focus:ds-outline-none focus:ds-rounded-full focus:ds-bg-primary-blue-50
      hover:ds-bg-background-grey hover:ds-rounded-full
    "
    [ngClass]="{
      '
        !ds-bg-primary-blue
        !ds-text-primary-white
        ds-rounded-full ds-tracking-wide
        ds-font-bold':
        isSelectedYear(year),

      'ds-text-primary-gray-70 
       ds-cursor-not-allowed
       ds-pointer-events-none':
        isDisabled(year)
    }"
    (click)="selectYearRange(year)"
    (keydown.enter)="selectYearRange(year)"
    (keydown.ArrowLeft)="focusPrevious(yearDom)"
    (keydown.ArrowUp)="focusPrevious(yearDom)"
    (keydown.ArrowRight)="focusNext(yearDom)"
    (keydown.ArrowDown)="focusNext(yearDom)"
  >
    {{ year }}
  </a>
</section>
<section
  class="
    ds-flex ds-flex-wrap ds-justify-center
    mb-4
    ds-max-w-lg ds-text-center ds-m-auto
  "
>
  <a
    tabindex="0"
    class="
      ds-pr-sm
      ds-text-right
      ds-text-xl
      ds-cursor-pointer
      ds-icon
      ds-icon-left
      ds-text-primary-blue
    "
    *ngIf="min.getFullYear() <= years[0]"
    (click)="past()"
    (keydown.enter)="past()"
  ></a>

  <a
    tabindex="0"
    class="
      ds-pl-sm
      ds-text-left
      ds-text-xl
      ds-cursor-pointer
      ds-icon
      ds-icon-right
      ds-text-primary-blue
    "
    *ngIf="max.getFullYear() > years[years.length - 1]"
    (click)="future()"
    (keydown.enter)="future()"
  ></a>
</section>
